import React from 'react';
import { INSURANCE_TYPE_INSURANCE, INSURANCE_TYPE_CASH, INSURANCE_TYPE_CASH_AND_INSURANCE } from 'constants/common';
import s from './s.module.less';

interface PaymentOption {
    value: string;
    label: string;
}

const PAYMENT_OPTIONS: PaymentOption[] = [
    { value: INSURANCE_TYPE_INSURANCE, label: 'Accept insurance only' },
    { value: INSURANCE_TYPE_CASH, label: 'Cash pay only' },
    { value: INSURANCE_TYPE_CASH_AND_INSURANCE, label: 'Both insurance and cash' },
];

interface Props {
    value?: string;
    onChange?: (value: string) => void;
}

const PaymentMethodStep: React.FC<Props> = ({ value, onChange }) => {
    return (
        <div className={s.wrap}>
            <h1 className={s.heading}>How would you like to get paid?</h1>
            <p className={s.description}>Please select your preferred payment method.</p>
            <div className={s.options}>
                {PAYMENT_OPTIONS.map((opt) => (
                    <div
                        key={opt.value}
                        className={`${s.option} ${value === opt.value ? s.selected : ''}`}
                        onClick={() => onChange?.(opt.value)}
                    >
                        {opt.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PaymentMethodStep;
